<template>
  <DocIndicadoresPrevineBrasil />
</template>

<script>
import DocIndicadoresPrevineBrasil from '@/components/utils/documentos/DocIndicadoresPrevineBrasil.vue'
export default {
  components: {
    DocIndicadoresPrevineBrasil,
  },
}
</script>

<style></style>
